import React, { ReactElement } from "react";
import Form from "@components/shared/form";
import styles from "./styles.module.scss";
import colors from "@styles/variables/contentintelligenceVariables.module.scss";

export default function MainBanner(): ReactElement {
    return (
        <div className={styles["main-banner"]}>
            <Form
                classes={{
                    formClassName: styles["form"],
                    stepTitleClassName: styles["step-title"],
                    stepClassName: styles["step-block"],
                    stepDescriptionClassName: styles["step-description"],
                    formButtonClassName: styles["form-button"],
                    formFieldClassName: styles["form-field"],
                    formStepInnerClassName: styles["steps-inner"],
                    fieldsClassName: {
                        radio: styles["radio-field"],
                        checkbox: styles["checkbox-field"],
                    },
                    fieldsWrapperClassName: styles["fields-wrapper"],
                    tcpaClassName: styles["tcpa"],
                    labelAsTitleClassName: styles["label-as-step-title"],
                    sellingPointClassName: styles["selling-point"],
                }}
                colors={{
                    primaryColor: colors.purple,
                    progressBar: colors.grey,
                }}
                showProgress={true}
                preventWindowClose
            />
        </div>
    );
}
